module.exports = __webpack_public_path__ + "static/media/cert_140.973d2e4c.jpg";